import { Box, Button, Flex, IconButton, Skeleton, Text } from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';

import { EquipmentLocation } from '@app/api/models';
import { useAlert, useApi } from '@app/hooks';
import { FieldView } from '@app/components/common';

export const OutletInfo = ({
  serialNumber,
  onShowOutletOnMap
}: { 
  serialNumber: string;
  onShowOutletOnMap(location: [number, number]): void;
}) => {
  const [location, setLocation] = useState<EquipmentLocation>();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingCoords, setIsLoadingCoords] = useState(false);
  const api = useApi();
  const { warning } = useAlert();
  
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const { data } = await api.equipments.getEquipmentsLocations({ 
        filter: { 
          serial_num: serialNumber,
        },
        limit: 1,
        offset: 0,
        sort: '+id',
      });
      setLocation(data.data[0]);
      setIsLoading(false);
    })();
  }, [serialNumber]);

  const onShowOutletOnMapClick = useCallback(async () => {
    if (!location?.outlet?.id) {
      warning('Не указан ID ТТ');
      return;
    }
    setIsLoadingCoords(true);
    const { data } = await api.acb.getMasterOutlet(Number(location.outlet.id));
    if (!data.address.latlng || !data.address.latlng.length || data.address.latlng[0] === null) {
      warning('Не определены координаты ТТ');
      return;
    }

    onShowOutletOnMap(data.address.latlng);
    setIsLoadingCoords(false);
  }, [location]);


  if (isLoading) {
    return <Box minH={120}>
      <Skeleton variant="rect" width="100%" height="120px" />
    </Box>;
  }

  return <Box>
    <Box mt={4} pb={0}>
      <Text fontSize='sm' color='brand.500'>
        {location?.outlet?.name}
      </Text>
      <Text fontSize='sm' color='gray.500'>
        {location?.outlet?.full_address}
      </Text>
      <FieldView title='ID' value={location?.outlet?.id} direction='row' canCopy fullWidth />  
      <FieldView title='ИНН' value={location?.outlet?.inn} direction='row' canCopy fullWidth /> 
      <FieldView title='Юр. наименование' value={location?.outlet?.legal_name} direction='row' canCopy fullWidth /> 
      <FieldView title='Вывеска' value={location?.outlet?.title} direction='row' fullWidth /> 
      <FieldView title='Тип' value={location?.outlet?.room_type?.name} direction='row' fullWidth />
      <FieldView title='Статус' value={location?.outlet.status?.name} direction='row' fullWidth />
      <Box mt={2} >
        <Button variant='outline' colorScheme='brand' size='sm' isLoading={isLoadingCoords} onClick={() => onShowOutletOnMapClick()}>
          Показать на карте
        </Button>
      </Box>
    </Box>
  </Box>;
};